<script setup>
import logger from "~/shared/utils/logger";

const props = defineProps({
  rootPath: {
    type: String,
    default: '/blog'
  }
})

const queryName = props.rootPath ? props.rootPath.slice(1).replace(/\//g, "_")+"-articles" : 'articles';


const { data: articles } = await useAsyncData(queryName, () => {
  const query = queryCollection('content')
    .where('path', 'LIKE', `${props.rootPath}%`)
    .order('title', 'ASC')

 if(import.meta.env.PROD) {
   query.where('published', '=', PublishedStatusEnum.Published)
 }

  return query.all()
})

if(!articles || !articles.value) {
  logger.warn(`No articles data found for rootPath ${props.rootPath}. Check your content collection and ensure there are documents with rootPaths starting with ${props.rootPath}.`);
} else {
  if(articles.value.length > 0) {
    logger.log(`Articles rootPath: ${props.rootPath}, queryName: ${queryName}, fetched ${articles.value.length} articles.`);
  } else {
    logger.log(`No articles found for rootPath ${props.rootPath}:`);
  }
}


</script>

<template>
  <section class="not-prose font-mono mr-2 md:mr-8">
    <div class="grid grid-cols-12 font-light text-sm capitalize italic md:text-lg/10 border-b">
      <div class="col-span-4 lg:col-span-3"/>
      <div class="col-span-8 lg:col-span-7">article</div>
      <div class="hidden lg:block lg:col-span-2">format</div>
    </div>
    <ul>
      <li v-for="article in articles" :key="article.path" class="article-list">
        <NuxtLink 
          v-if="article.path != props.rootPath && !article.is_list_exclude"
          :to="article.path" 
          class="grid grid-cols-12 border-b hover:bg-gray-00 dark:hover:bg-gray-600"
        >
          <div class="col-span-4 mx-auto lg:col-span-3 md:text-lg/9 font-light">
            <span v-if="article.image">
              <img :src="article.image" alt="article image" class="article-image max-h-10" >
            </span>
            <span v-else>
              No Image
            </span>
          </div>
          <div class="col-span-8 lg:col-span-7 font-semibold ml-1">
            {{ article.title }}<LinkStatus :published="article.published" />
          </div>
          <div class="hidden lg:block lg:col-span-2 align-text-top text-xs md:text-lg/9 font-light">
            {{ article.content_type }}
          </div>
        </NuxtLink>
      </li>
    </ul>
  </section>
</template>

<style lang="css" scoped>
.article-list:nth-child(even), .article-list:first-child {
    @apply bg-gray-200 dark:bg-gray-700;
}
</style>